import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import containerWidth from '../../../../shared/helpers/containerWidth';
import { required } from '../../../../shared/libs/reduxFormValidations';
import { resetSteps } from '../../../actions/stepActions';
import InputCheckbox from '../../FormElements/Checkbox/CheckBox';
import DropElement from '../../FormElements/DropElement/DropElement';
import InputText from '../../FormElements/Input/Input';
import PaymentElement from '../../FormElements/PaymentElement/PaymentElement';
import TextArea from '../../FormElements/TextArea/TextArea';

import './FifthScreen.scss';

// eslint-disable-next-line react/prefer-stateless-function
class FifthScreen extends Component {
  constructor() {
    super();
    this.handleIsPropertyOwnerClick = this.handleIsPropertyOwnerClick.bind(
      this,
    );
  }

  componentDidMount() {
    const {
      isBillingContactSameAsProperty,
      propertyOwnerName,
      propertyOwnerEmail,
      propertyOwnerPhone,
      change,
    } = this.props;
    if (!propertyOwnerName) {
      change('billingContactSameAsPropertyOwner', false);
    } else if (isBillingContactSameAsProperty) {
      change('billingContact.name', propertyOwnerName);
      change('billingContact.phone', propertyOwnerPhone);
      change('billingContact.', propertyOwnerEmail);
    }
  }

  handleIsPropertyOwnerClick(e) {
    const { name: inputName, value: inputValue } = e.target;
    const restInputNames = inputName === 'billingContactInvoiceMe'
      ? 'billingContactSameAsPropertyOwner'
      : 'billingContactInvoiceMe';
    const {
      propertyOwnerName,
      propertyOwnerEmail,
      propertyOwnerPhone,
      change,
      clearFields,
    } = this.props;
    let billingContactName = propertyOwnerName;
    let billingContactEmail = propertyOwnerEmail;
    let billingContactPhone = propertyOwnerPhone;
    if (inputName === 'billingContactInvoiceMe') {
      billingContactName = `${window.UserFirstName} ${window.UserLastName}`;
      billingContactEmail = window.anowUserEmail;
      billingContactPhone = null;
    }

    if (inputValue === 'false' || !inputValue) {
      change('billingContact.name', billingContactName);
      change('billingContact.phone', billingContactPhone);
      change('billingContact.email', billingContactEmail);
      change(restInputNames, false);
    } else {
      clearFields(
        true,
        true,
        'billingContact.name',
        'billingContact.phone',
        'billingContact.email',
      );
    }
  }

  render() {
    const {
      propertyOwnerName,
      isBillingContactSameAsProperty,
      isBillingContactInvoiceMe,
      config,
      requiresPreAuthorizedPayment,
      paymentMethodId,
      handleSubmit,
    } = this.props;
    return (
      <form
        onSubmit={handleSubmit}
        className="row order_form_fifth"
        id="wizard-form"
      >
        <div className={containerWidth}>
          <Field
            name="sharedNote"
            placeholder="Anything we need to know?"
            component={TextArea}
            label="Notes / Special Instructions"
            rows={3}
            required={config.notes?.r}
            validate={[].concat(config.notes?.r ? [required] : [])}
            hidden={config.notes?.h}
          />
          <Field
            name="attachedFiles"
            type="text"
            component={DropElement}
            label="Attach file(s)"
            uploadEndpoint="weborders"
            hidden={config.attachFiles?.h}
          />
          <div className="row mb-3 text-right">
            <div className="col">
              <small>
                <em>
                  *Please ensure file names match what you are uploading. Eg.
                  Supporting documents, purchase contracts, specs, etc.
                </em>
              </small>
            </div>
          </div>
          <Field
            name="paymentMethodId"
            type="text"
            component={PaymentElement}
            validate={[].concat(requiresPreAuthorizedPayment ? [required] : [])}
            skipTouchedValidation
          />
          {!paymentMethodId && (
            <>
              <div className="row">
                <label htmlFor="billingContact" className="col-auto">
                  Billing Contact Name
                </label>
                {propertyOwnerName && (
                  <div className="col">
                    <Field
                      name="billingContactSameAsPropertyOwner"
                      component={InputCheckbox}
                      label={`Is it ${propertyOwnerName}?`}
                      inputID="billingContactSameAsPropertyOwner"
                      bemClass="inline-narrow-checkbox"
                      onChange={this.handleIsPropertyOwnerClick}
                    />
                  </div>
                )}
                {window.isAuthenticated && (
                  <div className="col">
                    <Field
                      name="billingContactInvoiceMe"
                      component={InputCheckbox}
                      label="I&apos;m Paying"
                      inputID="billingContactInvoiceMe"
                      bemClass="inline-narrow-checkbox"
                      onChange={this.handleIsPropertyOwnerClick}
                    />
                  </div>
                )}
              </div>
              <Field
                name="billingContact.name"
                type="text"
                placeholder="Name"
                component={InputText}
                skipTouchedValidation
                inputID="billingContact"
                disabled={
                  isBillingContactSameAsProperty || isBillingContactInvoiceMe
                }
                validate={[].concat(config.billingContact?.r ? [required] : [])}
                hidden={config.billingContact?.h}
              />
              <div className="row">
                <div className="col-6">
                  <Field
                    name="billingContact.email"
                    type="text"
                    placeholder="E-mail"
                    component={InputText}
                    disabled={
                      isBillingContactSameAsProperty
                      || isBillingContactInvoiceMe
                    }
                    hidden={config.billingContact?.h}
                  />
                </div>
                <div className="col-6">
                  <Field
                    name="billingContact.phone"
                    type="text"
                    placeholder="Phone Number"
                    component={InputText}
                    disabled={
                      isBillingContactSameAsProperty
                      || isBillingContactInvoiceMe
                    }
                    hidden={config.billingContact?.h}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </form>
    );
  }
}

FifthScreen.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  clearFields: PropTypes.func.isRequired,
  propertyOwnerName: PropTypes.string,
  isBillingContactSameAsProperty: PropTypes.bool,
  isBillingContactInvoiceMe: PropTypes.bool,
  paymentMethodId: PropTypes.string,
  propertyOwnerEmail: PropTypes.string,
  propertyOwnerPhone: PropTypes.string,
  requiresPreAuthorizedPayment: PropTypes.bool.isRequired,
  config: PropTypes.objectOf(
    PropTypes.shape({
      r: PropTypes.bool,
      h: PropTypes.bool,
    }),
  ).isRequired,
};
FifthScreen.defaultProps = {
  propertyOwnerName: null,
  propertyOwnerEmail: null,
  propertyOwnerPhone: null,
  isBillingContactSameAsProperty: false,
  isBillingContactInvoiceMe: false,
  paymentMethodId: null,
};

const selector = formValueSelector('WizardOrderForm');

const ReachFifthScreen = connect((state) => {
  const isBillingContactSameAsProperty = selector(
    state,
    'billingContactSameAsPropertyOwner',
  );
  const isBillingContactInvoiceMe = selector(state, 'billingContactInvoiceMe');
  const propertyOwnerName = selector(state, 'propertyOwner.companyName');
  const propertyOwnerEmail = selector(state, 'propertyOwner.email');
  const propertyOwnerPhone = selector(state, 'propertyOwner.phone');
  const paymentMethodId = selector(state, 'paymentMethodId');

  return {
    isBillingContactSameAsProperty,
    isBillingContactInvoiceMe,
    propertyOwnerName,
    propertyOwnerEmail,
    propertyOwnerPhone,
    paymentMethodId,
    requiresPreAuthorizedPayment: window.isAuthenticated
      ? state.paymentDetails.requiresPreAuthorizedPayment
      : state.paymentDetails.guestRequiresPreAuthorizedPayment,
  };
})(FifthScreen);

export default reduxForm({
  form: 'WizardOrderForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  onSubmitSuccess: (result, dispatch, props) => {
    props.reset();
    dispatch(resetSteps());
  },
  validate: (values) => {
    const errors = {};
    const { billingContact } = values;
    if (
      (billingContact?.email || billingContact?.phone)
      && !billingContact?.name
    ) {
      errors.billingContact = {
        name: 'Billing Contact Name is required',
      };
    }
    return errors;
  },
})(ReachFifthScreen);
